import { supabase } from '@/lib/supabase';

export type PersonBand = { dimension: string; label: string; band_id?: string };

export type PersonRow = {
  employee_id: string;
  hash_prefix: string;
  signed_in: boolean;
  created_at: string;
  is_demo: boolean;
  bands: PersonBand[];
};

export type PendingInvite = {
  id: string;
  email: string;
  created_at: string;
  expires_at: string;
  bands: PersonBand[];
};

export type StageRow = { email: string; bands: PersonBand[] };
export type StageResult = { email: string; status: 'staged' | 'merged'; invitation_id: string | null };

export async function listPeople(orgId: string): Promise<PersonRow[]> {
  const { data, error } = await (supabase as any).rpc('admin_list_people', { _org_id: orgId });
  if (error) throw error;
  return (data ?? []) as PersonRow[];
}

export async function listPendingInvitations(orgId: string): Promise<PendingInvite[]> {
  const { data, error } = await (supabase as any).rpc('admin_list_pending_invitations', { _org_id: orgId });
  if (error) throw error;
  return (data ?? []) as PendingInvite[];
}

export async function stageInvitations(orgId: string, rows: StageRow[]): Promise<StageResult[]> {
  const { data, error } = await (supabase as any).rpc('admin_stage_invitations', {
    _org_id: orgId,
    _rows: rows,
  });
  if (error) throw error;
  return (data ?? []) as StageResult[];
}

export type BandLabel = { dimension: string; label: string; member_count: number };

export async function listBandLabels(orgId: string): Promise<BandLabel[]> {
  const { data, error } = await (supabase as any).rpc('admin_list_band_labels', { _org_id: orgId });
  if (error) throw error;
  return (data ?? []) as BandLabel[];
}

export async function revokeInvitation(invitationId: string): Promise<void> {
  const { error } = await (supabase as any).rpc('admin_revoke_invitation', { _invitation_id: invitationId });
  if (error) throw error;
}

export async function unassignBand(orgId: string, employeeId: string, bandId: string): Promise<void> {
  const { error } = await (supabase as any).rpc('admin_unassign_band', {
    _org_id: orgId,
    _employee_id: employeeId,
    _band_id: bandId,
  });
  if (error) throw error;
}

export async function resendInvitation(invitationId: string): Promise<{ ok: boolean; error?: string }> {
  const { data, error } = await (supabase as any).rpc('admin_resend_invitation', {
    p_invitation_id: invitationId,
  });
  if (error) throw error;
  return (data ?? { ok: false }) as { ok: boolean; error?: string };
}
